// import Vue from 'vue'
import App from './App'
import router from './router'
// import ElementUi from 'element-ui'
// import 'element-ui/lib/theme-chalk/index.css'
import util from './api/util.js'
// import { Message } from 'element-ui'
import store from './vuex/store'
import './element-variables.scss'

// Vue.use(ElementUi)
Vue.config.productionTip = false;
Vue.prototype.$center = new Vue() // 非父子组件传值

if (process.env.NODE_ENV === "production") {
	// 线上
	router.beforeEach((to, from, next) => {
		if (to.matched.some(record => record.meta.requireAuth)) { // 判断该路由是否需要登录权限
			if (util.getCookie('auth') == null) {
				if (window.configFlag == true) { // 如果是第一次进入
					window.configFlag = false;
					next({ path: '/login' })
				} else {
					ELEMENT.Message({ message: '您已下线，请重新登录', type: 'warning' });
					next({ path: '/login' })
				}
			} else {
				next();
			}
		} else {
			next();
		}
	})
}

new Vue({
	el: '#app',
	router,
	store,
	template: '<App/>',
	components: { App }
})


// WEBPACK FOOTER //
// ./src/main.js